import { json } from "react-router-dom";
import { Axios } from "../../../util";
import axios from "axios";

const getRequestStatus = async (customerId) => {
  try {
    const res = await Axios.post(`/api/request/getRequestStatus?customerId=${customerId}`,
    );
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const getRequestStatusDetail = async (customerId,subject,status,date) => {
  try {
    const res = await Axios.post(`/api/request/getRequestStatusDetail?customerId=${customerId}&subject=${subject}&status=${status}&date=${date}`
    );
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};

const updateRequestStatus = async (customerId,subject,status,date) => {
  try {
    const res = await Axios.post(`/api/request/updateRequestStatus?customerId=${customerId}&subject=${subject}&status=${status}&date=${date}`
    );
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};




export { getRequestStatus,
        getRequestStatusDetail,
        updateRequestStatus
         
 };
